import React, { SVGProps } from 'react';

const TriangleIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M1.34487 0.5H10.6549C10.8197 0.500035 10.9807 0.548928 11.1178 0.640498C11.2548 0.732068 11.3615 0.862204 11.4246 1.01445C11.4877 1.1667 11.5042 1.33423 11.472 1.49586C11.4399 1.65748 11.3605 1.80595 11.244 1.9225L6.58904 6.57749C6.43277 6.73371 6.22084 6.82148 5.99987 6.82148C5.7789 6.82148 5.56698 6.73371 5.41071 6.57749L0.755708 1.9225C0.6392 1.80595 0.559861 1.65748 0.527722 1.49586C0.495582 1.33423 0.512085 1.1667 0.575143 1.01445C0.638201 0.862204 0.744984 0.732068 0.881993 0.640498C1.019 0.548928 1.18008 0.500035 1.34487 0.5Z"
                fill="white"
            />
        </svg>
    );
};

export default TriangleIcon;
